import { Badge } from '@/components';
import { Tags } from '../models';

interface BadgeColors {
  bg: string;
  text: string;
}

const green: BadgeColors = { bg: '#C8E6C9', text: '#2E7D32' };
const white: BadgeColors = { bg: '#222831', text: '#F5F5F5' };
const red: BadgeColors = { bg: '#FFCDD2', text: '#C62828' };

export const tagsTranslation: Record<string, string> = {
  LOST: 'EXTRAVIADO',
  PREPARED: 'PREPARADO',
};

export const tagsColors: Record<string, BadgeColors> = {
  LOST: red,
  PREPARED: green,
  UNKNOWN: white,
};

const getColorProps = (colors: Record<Tags, BadgeColors>, value: Tags) => {
  const color = colors[value] || white;

  return {
    backgroundColor: color.bg,
    textColor: color.text,
  };
};

const renderTags = (tags: string) => (
  <div className='flex flex-wrap gap-1 max-w-md'>
    {tags
      ?.replaceAll(' ', '')
      ?.split(',')
      .map((rawTag) => {
        const tag = rawTag as Tags;
        const translated = tagsTranslation[tag] || tag;
        const colorProps = getColorProps(tagsColors, tag);

        return (
          <div key={tag} style={{ width: 'fit-content' }}>
            <Badge {...colorProps} value={translated} showBall={false} />
          </div>
        );
      })}
  </div>
);

export default renderTags;
